import { render, staticRenderFns } from "./PreviewItem.vue?vue&type=template&id=3de5a100&"
import script from "./PreviewItem.vue?vue&type=script&lang=js&"
export * from "./PreviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports